<template>
  <b-form-group
    label="Proje Sayısı"
    label-for="projects_number"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje Sayısı"
      rules="required"
    >
      <b-form-input
        id="projects_number"
        v-model="itemData.projects_number"
        placeholder="Proje Sayısı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'YearText.',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
